import { Box, Button, Stack, Typography, styled } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LibrarySave, PackData, SaveableBase } from "../../model/character";
import { saveLibraryData } from "../../master/libraryData";
import Page from "../../components/Page";
import { Pack } from "../../master/data";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FILE_NAMES: { [k:string]: string} = {
    "lwm": "Weapon Mod",
    "lwv": "Weapon Variation",
    "lw": "Weapon",
    "lom": "Outfit Mod",
    "lov": "Outfit Variation",
    "lo": "Outfit",
    "lspec": "Species",
    "lcomwep": "Companion (Weapon)",
    "lmi": "Misc Item",
    "tg": "Trade Good",
    "lut": "Utility",
    "ltr": "Trait",
    "lpe": "Perk",
    "lco": "Complication",
    "lp": "Pack"
}

const Import = () => {
    const navigate = useNavigate();
    
    const [file, setFile] = useState<LibrarySave>();
    const [fileError, setFileError] = useState<string>();
    const reader = new FileReader();
    reader.onload = function(event) {
        if(event.target === null){
            setFile(undefined)
            setFileError("File upload error");
        }
        else {
            if(typeof(event.target.result) === 'string'){
                const data = event.target.result;
                const loaded: LibrarySave = JSON.parse(data);
                setFile(loaded);
            }else{
                setFileError("Wrong file type");
            }
        }
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files !== null) {
            try {
                const file = event.target.files[0];
                reader.readAsText(file);
            } catch (e: any) {
                setFile(undefined);
                setFileError("File upload error");
            }
        }
    }

    const handleSave = () => {
        let prefix = file?.ftype ?? "";

        if(!["lwm", "lwv", "lw", "lom", "lov", "lo", "lspec", "lcomwep"
            , "lmi", "tg", "lut", "ltr", "lpe", "lco", "lp"].includes(prefix)) return
            
        //@ts-ignore
        delete file?.ftype;

        const saveItems = (prefix: string, data: any[]) => {
            for(const d of data) {
                saveLibraryData(prefix, d);
            }
        }

        if(prefix === "lp") {
            const packData = file as unknown as PackData;
            saveItems("lw", packData.weapons);
            saveItems("lwm", packData.weaponMods);
            saveItems("lwv", packData.weaponVariations);
            saveItems("lo", packData.outfits);
            saveItems("lom", packData.outfitMods);
            saveItems("lov", packData.outfitVariation);
            saveItems("lut", packData.utilities);
            saveItems("lmi", packData.miscItems);
            saveItems("lspec", packData.species);
            saveItems("lcomwep", packData.companionWeapons);
            saveItems("ltr", packData.traits);
            saveItems("lpe", packData.perks);
            saveItems("lco", packData.complications);
            const pack: Pack = {
                id: packData.id,
                name: packData.name,
                miscItems: packData.miscItems.map(d => d.id),
                outfitMods: packData.outfitMods.map(d => d.id),
                outfits: packData.outfits.map(d => d.id),
                outfitVariations: packData.outfitVariation.map(d => d.id),
                utilities: packData.utilities.map(d => d.id),
                weaponMods: packData.weaponMods.map(d => d.id),
                weapons: packData.weapons.map(d => d.id),
                weaponVariations: packData.weaponVariations.map(d => d.id),
                species: packData.species.map(d => d.id),
                companionWeapons: packData.companionWeapons.map(d => d.id),
                perks: packData.perks.map(d => d.id),
                traits: packData.traits.map(d => d.id),
                complications: packData.complications.map(d => d.id),
            }
            saveLibraryData("lp", pack);
        } else {
            saveLibraryData(prefix, file!);
        }

        navigate("/library");
    }

    return <Page>
        <Box paddingY={3} textAlign="center">
            <Stack direction="column" spacing={2}>
                <Typography variant="h3" textAlign="center">Import Library Item</Typography>
                {file !== undefined ? <>
                    <Typography variant="h4">{file.name}</Typography>
                    <div>Type: {FILE_NAMES[file.ftype]}</div>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button variant="contained" onClick={() => handleSave()}>Save</Button>
                        <Button variant="contained" onClick={() => setFile(undefined)}>Clear</Button>
                    </Stack>
                    </> : <>
                        {fileError !== undefined && <Typography>{fileError}</Typography>}
                        <Stack direction="row" spacing={2} justifyContent="center">
                        <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
                            Upload file
                            <VisuallyHiddenInput type="file" accept="fnl" onChange={handleFileChange} />
                        </Button>
                    </Stack>
                </>}
                    
            </Stack>
        </Box>
    </Page>;
        
}

export default Import